var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11853_7601",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11853_7601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05 12.9984C5.76667 12.9984 5.52083 12.8943 5.3125 12.6859C5.10417 12.4776 5 12.2318 5 11.9484C5 11.6651 5.10417 11.4193 5.3125 11.2109C5.52083 11.0026 5.76667 10.8984 6.05 10.8984H17.95C18.2333 10.8984 18.4792 11.0026 18.6875 11.2109C18.8958 11.4193 19 11.6651 19 11.9484C19 12.2318 18.8958 12.4776 18.6875 12.6859C18.4792 12.8943 18.2333 12.9984 17.95 12.9984H6.05Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterRed);
export default __webpack_public_path__ + "static/media/center_red.425a77b0eef01da7394ddbd94cfb1318.svg";
export { ForwardRef as ReactComponent };